import Promise from 'bluebird';
import { IObservable, IObserver, ISubscription } from './types';

export function promisifyObservable<T = unknown, E = unknown>(observable: IObservable<T, E>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    let subscription: ISubscription<T, E>;

    // `subscription` needs to be declared in a previous line because it's referenced in the callbacks.
    // eslint-disable-next-line prefer-const
    subscription = observable.subscribe({
      next: (data: T) => {
        resolve(data);
        if (subscription) {
          subscription.unsubscribe();
        }
      },
      error: (err: E) => {
        reject(err);
        if (subscription) {
          subscription.unsubscribe();
        }
      },
    } as IObserver<T, E>);
  });
}
